(() => {
  class LemonaidPharmacyTableController {
    constructor(ngDialog, Utils, localStorageService, Services) {
      'ngInject';

      Object.assign(this, {
        ngDialog,
        Utils,
        localStorageService,
        Services,
        edServicesFirstShipment: []
      });
      this, Services.getCachedPimsParameters(true).then(pimsParameters => {
        if (pimsParameters && pimsParameters.pharmacyTab && pimsParameters.pharmacyTab.edServicesFirstShipment && pimsParameters.pharmacyTab.edServicesFirstShipment.length) this.edServicesFirstShipment = pimsParameters.pharmacyTab.edServicesFirstShipment;
      });
    }

    isFirstEDShipment(pharmacyfill) {
      if (this.edServicesFirstShipment.includes(pharmacyfill.category.code) && pharmacyfill.auto_refill && pharmacyfill.shipment && pharmacyfill.shipment.count === 1) {
        return true;
      } else {
        return false;
      }
    }

    showDetails(pharmacyfill) {
      this.openLemonaidPharmacyForm(pharmacyfill, response => {
        if (response && response.success) {
          // Details updated
          // We need to refresh the list
          this.onPageChange();
        } else {// User closed the popup
          // Do nothing
        }
      });
    }

    openLemonaidPharmacyForm(pharmacyfill, callback) {
      return this.ngDialog.open({
        template: 'app/components/lemonaid-pharmacy-form/lemonaid-pharmacy-form.html',
        // To not allow the user closes the modal without explicitely to have some action
        // select the X to close
        // closeByEscape: false,
        // closeByNavigation: false,
        // closeByDocument: false,
        // To make possible doctor still be able to use the screen behind
        // overlay: false,
        controller: 'LemonaidPharmacyFormController',
        controllerAs: '$ctrl',
        className: 'ngdialog-theme-default lemonaid-pharmacy-form-modal',
        data: {
          pharmacyfill_id: pharmacyfill.id
        },

        /**
         * @param {string|object} res - res will be an object if a pharmacy is selected
         */
        preCloseCallback(res) {
          if (typeof res === 'object') {
            return callback(res);
          }

          return callback(false);
        }

      });
    }

  }

  LemonaidPharmacyTableController.$inject = ["ngDialog", "Utils", "localStorageService", "Services"];
  angular.module('pims').component('lemonaidPharmacyTable', {
    templateUrl: 'app/components/lemonaid-pharmacy-table/lemonaid-pharmacy-table.html',
    controller: LemonaidPharmacyTableController,
    bindings: {
      pagination: '=',
      sortBy: '=',
      sortOrder: '=',
      onPageChange: '&',
      onSort: '&',
      pharmacyfills: '<'
    }
  });
})();